module.exports = __webpack_public_path__ + "static/media/comment-alt.6fd90bec.svg";